import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialsSection = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Homeowner",
    location: "Johannesburg",
    category: "emergency",
    rating: 5,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ad9e1013-1763294640440.png",
    imageAlt: "Professional woman with shoulder-length brown hair wearing blue blouse smiling warmly at camera",
    problem: "Complete power outage at 2 AM",
    solution: "Gert arrived within 45 minutes and diagnosed a faulty main breaker. Had us back up and running before sunrise.",
    testimonial: "I was terrified when we lost all power in the middle of the night with two young children. Gert answered immediately, arrived quickly, and worked efficiently to restore our power. His calm professionalism and expertise were exactly what we needed in that stressful situation.",
    date: "2026-01-05"
  },
  {
    id: 2,
    name: "David Chen",
    role: "Restaurant Owner",
    location: "Pretoria",
    category: "commercial",
    rating: 5,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a99cc915-1763299240589.png",
    imageAlt: "Asian businessman in formal black suit with confident smile in professional office setting",
    problem: "Kitchen equipment causing circuit trips",
    solution: "Upgraded electrical capacity and installed dedicated circuits for commercial kitchen equipment.",
    testimonial: "Running a restaurant, electrical issues can shut down our entire operation. Gert not only fixed our immediate problem but also identified potential issues and upgraded our system to handle our equipment properly. His commercial experience really shows.",
    date: "2025-12-28"
  },
  {
    id: 3,
    name: "Linda van der Merwe",
    role: "Property Manager",
    location: "Cape Town",
    category: "residential",
    rating: 5,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f8f896f2-1763299689286.png",
    imageAlt: "Professional woman with blonde hair in business attire with warm smile in modern office",
    problem: "Flickering lights throughout property",
    solution: "Identified and repaired loose connections in main distribution board and replaced aging wiring.",
    testimonial: "Managing multiple properties, I need electricians I can trust completely. Gert has become my go-to for all electrical work. His thorough inspections and honest assessments have saved me from potential disasters. He explains everything clearly and his work is always top quality.",
    date: "2025-12-15"
  },
  {
    id: 4,
    name: "James Naidoo",
    role: "Homeowner",
    location: "Durban",
    category: "emergency",
    rating: 5,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_192ceb5da-1763295388596.png",
    imageAlt: "Indian man with short black hair wearing casual blue shirt with friendly expression",
    problem: "Sparking outlet with burning smell",
    solution: "Emergency response, replaced faulty outlet and inspected entire circuit for safety.",
    testimonial: "When I saw sparks and smelled burning, I panicked. Gert talked me through what to do immediately over the phone, then arrived within the hour. He didn't just fix the outlet - he checked the entire circuit to make sure we were safe. That's the kind of thoroughness you want in an electrician.",
    date: "2026-01-08"
  },
  {
    id: 5,
    name: "Michelle Botha",
    role: "Retail Store Manager",
    location: "Johannesburg",
    category: "commercial",
    rating: 5,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_173b85801-1763296473353.png",
    imageAlt: "Professional woman with long dark hair in business casual attire with confident smile",
    problem: "Frequent power interruptions affecting POS systems",
    solution: "Installed dedicated circuits and surge protection for critical business systems.",
    testimonial: "Our POS systems kept going down, costing us sales and frustrating customers. Gert diagnosed the problem quickly and implemented a solution that has eliminated the issue completely. His understanding of commercial needs and minimal disruption to our operations was impressive.",
    date: "2025-12-20"
  },
  {
    id: 6,
    name: "Robert Kruger",
    role: "Homeowner",
    location: "Pretoria",
    category: "residential",
    rating: 5,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a424e8a2-1763294679746.png",
    imageAlt: "Middle-aged man with gray hair wearing casual shirt with warm friendly smile",
    problem: "Home renovation electrical upgrade",
    solution: "Complete rewiring of renovated areas with modern safety features and smart home integration.",
    testimonial: "During our home renovation, Gert handled all the electrical work. His attention to detail and suggestions for modern features like smart switches and USB outlets really enhanced our project. He coordinated perfectly with our other contractors and his work passed inspection with flying colors.",
    date: "2025-11-30"
  }];


  const filters = [
  { id: 'all', label: 'All Reviews', icon: 'Star' },
  { id: 'emergency', label: 'Emergency', icon: 'AlertTriangle' },
  { id: 'commercial', label: 'Commercial', icon: 'Building2' },
  { id: 'residential', label: 'Residential', icon: 'Home' }];


  const filteredTestimonials = activeFilter === 'all' ?
  testimonials :
  testimonials?.filter((t) => t?.category === activeFilter);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    return `${Math.floor(diffDays / 30)} months ago`;
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-headline font-bold text-2xl md:text-3xl lg:text-4xl text-foreground mb-4">
            Client Success Stories
          </h2>
          <p className="font-body text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            Real experiences from homeowners and businesses who trust Gert for their electrical needs. Every review represents a problem solved and peace of mind restored.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-8 md:mb-12">
          {filters?.map((filter) =>
          <button
            key={filter?.id}
            onClick={() => setActiveFilter(filter?.id)}
            className={`flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 rounded-full font-accent text-sm md:text-base transition-all duration-300 ${
            activeFilter === filter?.id ?
            'bg-primary text-primary-foreground shadow-lg' :
            'bg-card border border-border hover:border-primary'}`
            }>

              <Icon name={filter?.icon} size={18} />
              <span>{filter?.label}</span>
            </button>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {filteredTestimonials?.map((testimonial) =>
          <div
            key={testimonial?.id}
            className="bg-card border border-border rounded-xl p-6 md:p-8 hover:shadow-elevated transition-all duration-300">

              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full overflow-hidden flex-shrink-0">
                    <Image
                    src={testimonial?.image}
                    alt={testimonial?.imageAlt}
                    className="w-full h-full object-cover" />

                  </div>
                  <div>
                    <h4 className="font-headline font-semibold text-base text-foreground">
                      {testimonial?.name}
                    </h4>
                    <p className="font-body text-xs text-muted-foreground">
                      {testimonial?.role} • {testimonial?.location}
                    </p>
                  </div>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(testimonial?.rating)]?.map((_, i) =>
                <Icon key={i} name="Star" size={14} color="var(--color-accent)" fill="var(--color-accent)" />
                )}
                </div>
              </div>

              <div className="mb-4">
                <div className="flex items-start gap-2 mb-2">
                  <Icon name="AlertCircle" size={16} color="var(--color-error)" className="mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-accent text-xs text-muted-foreground uppercase mb-1">Problem</p>
                    <p className="font-body text-sm text-foreground">{testimonial?.problem}</p>
                  </div>
                </div>
                <div className="flex items-start gap-2">
                  <Icon name="CheckCircle2" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-accent text-xs text-muted-foreground uppercase mb-1">Solution</p>
                    <p className="font-body text-sm text-foreground">{testimonial?.solution}</p>
                  </div>
                </div>
              </div>

              <blockquote className="font-body text-sm text-muted-foreground italic mb-4 border-l-4 border-primary pl-4">
                "{testimonial?.testimonial}"
              </blockquote>

              <div className="flex items-center justify-between pt-4 border-t border-border">
                <span className="font-body text-xs text-muted-foreground">
                  {formatDate(testimonial?.date)}
                </span>
                <span className="inline-flex items-center gap-1 px-2 py-1 bg-success/10 text-success rounded-full text-xs font-accent">
                  <Icon name="BadgeCheck" size={12} />
                  Verified
                </span>
              </div>
            </div>
          )}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex flex-col items-center gap-4 bg-card border border-border rounded-xl p-6 md:p-8">
            <div className="flex items-center gap-2">
              <Icon name="Star" size={32} color="var(--color-accent)" fill="var(--color-accent)" />
              <div className="text-left">
                <div className="font-headline font-bold text-3xl text-foreground">5.0</div>
                <div className="font-body text-sm text-muted-foreground">Average Rating</div>
              </div>
            </div>
            <p className="font-body text-sm text-muted-foreground max-w-md">
              Based on {testimonials?.length} verified reviews from satisfied clients across residential and commercial projects
            </p>
          </div>
        </div>
      </div>
    </section>);

};

export default TestimonialsSection;